import React from 'react';
import { makeStyles } from 'design-system/styles';
import Alert from 'design-system/Alert';

const DownloadableViewError = () => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <Alert severity="error">
        An error occurred loading the task. Please report this to the remotasks support team by
        clicking "Skip" below
      </Alert>
    </div>
  );
};

const useStyles = makeStyles({
  container: {
    margin: 24,
  },
});

export default DownloadableViewError;
